import { Typography } from '@mui/material';
import { PageNumber } from '../../StaticContent/PageNumber';
import { WatermarkLogo } from '../../StaticContent/WatermarkLogo';
import { Root } from '../components/Root';
import { TitleBox } from '../components/TitleBox';
import { TitleBoxTypography } from '../components/TitleBoxTypography';

export const DisclaimerPage = ({ pageNumber }: { pageNumber: number }) => {
  return (
    <Root
      sx={{
        padding: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
      }}
    >
      <TitleBox>
        <TitleBoxTypography>DISCLAIMER</TitleBoxTypography>
      </TitleBox>

      <Typography mt={2}>
        THIS DOCUMENT AND THE INFORMATION IN IT MAY NOT BE USED, PUBLISHED OR REDISTRIBUTED WITHOUT
        THE PRIOR WRITTEN CONSENT OF WELLIGENCE INC. THE INFORMATION CONTAINED WITHIN THIS DOCUMENT
        IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. WELLIGENCE DOES NOT WARRANT THE
        ACCURACY, ADEQUACY, OR COMPLETENESS OF THIS INFORMATION, AND EXPRESSLY DISCLAIMS LIABILITY
        FOR ERRORS OR OMISSIONS IN THEM.
      </Typography>

      <WatermarkLogo />
      <PageNumber pageNumber={pageNumber.toString()} />
    </Root>
  );
};
